var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('footer', {
    staticClass: "disclosure-footer mt-16 text-sm text-left"
  }, [_c('p', [_vm._v("\n\t\tThe Aligned Company d/b/a Extra (“Extra”) is a technology company, not a bank. The Extra Debit\n\t\tCard is issued by Evolve Bank & Trust or Patriot Bank N.A. (Member FDIC), pursuant to a\n\t\tlicense by Mastercard International. Line of credit provided by Lead Bank. This Card can be\n\t\tused everywhere Debit Mastercard is accepted. Extra is responsible for credit reporting and\n\t\treports on time and late payments, which may impact a credit bureau’s determination of your\n\t\tcredit score. Credit scores are independently determined by credit bureaus based on a number\n\t\tof factors, including your other financial transactions. Extra reports to Experian® and\n\t\tEquifax®. The Extra Debit Card and related services will not remove negative credit history\n\t\tfrom your credit report. Rewards points only available with rewards plan. Membership fees\n\t\tapply. Please refer to our\n\t\t"), _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "/legal/terms"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" and\n\t\t"), _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "/legal/cardholder-agreement"
    }
  }, [_vm._v("Cardholder Agreement")]), _vm._v(" for\n\t\tadditional details.\n\t")])]);
}];
export { render, staticRenderFns };